// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function openFile({ file,url,version}) {
  const uri = url || file;
  if (version!=='1') {
    window.open('https://fileview.xddkj.cn/onlinePreview?url='+window.btoa(uri));
    return;
  }
  window.open("https://smartopen.xddkj.cn/pdf/web/viewer.html?file=" + encodeURIComponent(uri));
}


export async function downloadFile({ response,fileName,url}) {
  if(url){
    return window.open(url)
  }

  if(response.data && response.data.type == 'application/json'){
    const data = JSON.parse(await response.data.text())
    return Promise.reject(data)
  }
  if (!fileName) {
    const strs = response.headers['content-disposition'].split(/''|=/)
    fileName =  decodeURIComponent(strs[strs.length-1])
  }

  const data = response.data
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(new Blob([data]), fileName)
  } else {
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link); //下载完成移除元素
    window.URL.revokeObjectURL(url); //释放掉blob对象
  }

}
